export function getExamDataStatusDescription(
  description: string,
): string {
  switch (description) {
    case 'archived':
      return 'Imported';
    case 'new':
    default:
      return 'Not yet imported';
  }
}